// extracted by mini-css-extract-plugin
var _1 = "PostStickyControl-module__actionButtons--xUuAG";
var _2 = "PostStickyControl-module__animatedBackground--IeSxH";
var _3 = "PostStickyControl-module__closeAreaButton--Aqyjy";
var _4 = "PostStickyControl-module__container--enpOm";
var _5 = "PostStickyControl-module__content--N6gxQ";
var _6 = "PostStickyControl-module__hasBanner--DfwYT";
var _7 = "PostStickyControl-module__isPublicView--I6oJY";
var _8 = "PostStickyControl-module__isShowingTOC--TgUis";
var _9 = "PostStickyControl-module__monitor--JzZ4p";
var _a = "8px";
var _b = "PostStickyControl-module__scrolled--Z_fwg";
var _c = "PostStickyControl-module__tablet--DyiS9";
var _d = "PostStickyControl-module__title--QnsrF";
var _e = "PostStickyControl-module__tocButton--bugI2";
var _f = "PostStickyControl-module__tocContainer--fLJNJ";
var _10 = "PostStickyControl-module__tocPopOverContainer--Ulb42";
var _11 = "PostStickyControl-module__tocPopOverContent--eWSyF";
var _12 = "PostStickyControl-module__tocPopOverFloating--XRPFm";
var _13 = "17px";
export { _1 as "actionButtons", _2 as "animatedBackground", _3 as "closeAreaButton", _4 as "container", _5 as "content", _6 as "hasBanner", _7 as "isPublicView", _8 as "isShowingTOC", _9 as "monitor", _a as "postActionsTopOffset", _b as "scrolled", _c as "tablet", _d as "title", _e as "tocButton", _f as "tocContainer", _10 as "tocPopOverContainer", _11 as "tocPopOverContent", _12 as "tocPopOverFloating", _13 as "topOffsetWithoutStateBar" }
